import React from 'react';
import { Link } from 'react-router-dom';

// 1. シミュレーション画像をインポート
import serviceAiTrainingSubsidySimulationImg from '@/src/assets/images/service-ai-training-subsidy-simulation.png';

const AITrainingPage: React.FC = () => {
    return (
        <div className="pt-20"> {/* Header offset */}
            <section className="bg-gray-50 py-20 md:py-32 text-center">
                <div className="container mx-auto px-6">
                    <h1 className="text-4xl md:text-5xl font-extrabold text-[#3aabd2] tracking-tight">AI研修事業</h1>
                    <p className="mt-4 text-lg md:text-xl text-gray-800 font-semibold">社員のAI活用スキルを実践的に育成</p>
                    <p className="mt-4 max-w-3xl mx-auto text-gray-600">
                        基礎知識の習得から実業務での活用まで、段階的な学習プログラムで組織全体のAIリテラシー向上をサポートします。
                    </p>
                    <Link to="/contact" className="mt-8 inline-block bg-[#3aabd2] text-white font-bold py-3 px-8 rounded-lg shadow-lg hover:bg-[#2f8faf] transition-transform transform hover:-translate-y-1">
                        お問い合わせはこちら
                    </Link>
                </div>
            </section>

            <section className="py-20 bg-white">
                <div className="container mx-auto px-6">
                    <h2 className="text-3xl font-bold text-center mb-12 relative pb-4 after:content-[''] after:absolute after:left-1/2 after:-translate-x-1/2 after:bottom-0 after:w-16 after:h-1 after:bg-[#3aabd2] after:rounded-full">
                        AI研修事業の特徴
                    </h2>
                    <div className="grid md:grid-cols-3 gap-8 text-center">
                        <div className="bg-gray-50 p-8 rounded-xl shadow-md border border-gray-200 hover:shadow-xl hover:border-[#3aabd2] transition-all duration-300 transform hover:-translate-y-2">
                            <h3 className="text-xl font-bold mb-4">現場に即した実践的プログラム</h3>
                            <p className="text-gray-600">理論だけでなく、実際の業務で使えるスキルに重点を置いた研修プログラムを提供します。</p>
                        </div>
                        <div className="bg-gray-50 p-8 rounded-xl shadow-md border border-gray-200 hover:shadow-xl hover:border-[#3aabd2] transition-all duration-300 transform hover:-translate-y-2">
                            <h3 className="text-xl font-bold mb-4">ハンズオン形式の体験学習</h3>
                            <p className="text-gray-600">実際にAIツールを触りながら学ぶことで、研修後すぐに現場で活用できる実力を身につけます。</p>
                        </div>
                        <div className="bg-gray-50 p-8 rounded-xl shadow-md border border-gray-200 hover:shadow-xl hover:border-[#3aabd2] transition-all duration-300 transform hover:-translate-y-2">
                            <h3 className="text-xl font-bold mb-4">社内展開までサポート</h3>
                            <p className="text-gray-600">研修を受けた方が社内で知識を展開できるよう、教育資料の提供や指導方法もお伝えします。</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-20 bg-gray-50">
                <div className="container mx-auto px-6">
                    <h2 className="text-3xl font-bold text-center mb-12 relative pb-4 after:content-[''] after:absolute after:left-1/2 after:-translate-x-1/2 after:bottom-0 after:w-16 after:h-1 after:bg-[#3aabd2] after:rounded-full">
                        研修コース一覧
                    </h2>
                    <p className="text-center text-2xl font-bold text-gray-800 mb-8">
                        受講費用：1人あたり35万円(税別)
                    </p>
                    <div className="max-w-2xl mx-auto bg-white rounded-xl shadow-lg border border-gray-200 p-8">
                        <ul className="space-y-4">
                            {['業務効率化コース', '不動産コース', '製造業コース', '接客業コース', '税理士コース', 'クリエイティブコース', '飲食業コース', '物流・運送業コース', '業務効率化コース（e-learning形式）', '不動産コース（e-learning形式）', '製造業コース（e-learning形式）', '接客業コース（e-learning形式）', '税理士コース（e-learning形式）', 'クリエイティブコース（e-learning形式）', '飲食業コース（e-learning形式）', '物流・運送業コース（e-learning形式）'].map(course => (
                                <li key={course} className="flex items-center text-gray-800 text-lg border-b border-gray-200 pb-4 last:border-b-0 last:pb-0">
                                    <span className="text-2xl text-[#3aabd2] mr-4 font-bold">&#8226;</span>
                                    {course}
                                </li>
                            ))}
                        </ul>
                        <div className="mt-8 text-sm text-gray-600 space-y-1">
                            <p>※e-LearningはLMSによりユーザー毎の学習状況・分析がリアルタイムで可能です。</p>
                            <p>※e-Learningの標準学習期間は60日です</p>
                        </div>
                    </div>
                </div>
            </section>
            
            <section className="py-20 bg-white">
                <div className="container mx-auto px-6">
                     <h2 className="text-3xl md:text-4xl font-bold text-center mb-6">
                        e-Learning形式でも安心の受講形式
                    </h2>
                    <p className="text-center font-bold text-lg md:text-xl mb-16">
                        <span className="text-red-600">PCやスマホがあれば</span>
                        <span className="text-gray-800">どこからでもアクセスして視聴が可能です。</span>
                    </p>

                    <div className="grid md:grid-cols-3 gap-8 mb-20">
                        <div className="bg-white p-8 rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.08)] border border-gray-100 text-center flex flex-col items-center">
                            <div className="mb-6">
                                <svg className="w-20 h-20 text-[#3aabd2]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
                                </svg>
                            </div>
                            <h3 className="text-xl font-bold text-[#3aabd2] mb-3">視聴ログ</h3>
                            <p className="text-sm font-bold text-gray-800 leading-relaxed">
                                会員の視聴履歴を追跡し、<br/>コンテンツの使用状況を分析
                            </p>
                        </div>
                        <div className="bg-white p-8 rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.08)] border border-gray-100 text-center flex flex-col items-center">
                            <div className="mb-6">
                                <svg className="w-20 h-20 text-[#3aabd2]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
                                </svg>
                            </div>
                            <h3 className="text-xl font-bold text-[#3aabd2] mb-3">視聴分析</h3>
                            <p className="text-sm font-bold text-gray-800 leading-relaxed">
                                視聴者の動画視聴分析を<br/>分かりやすくグラフ化
                            </p>
                        </div>
                        <div className="bg-white p-8 rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.08)] border border-gray-100 text-center flex flex-col items-center">
                            <div className="mb-6">
                                <svg className="w-20 h-20 text-[#3aabd2]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M7 4v16M17 4v16M3 8h4m10 0h4M3 12h18M3 16h4m10 0h4M4 20h16a1 1 0 001-1V5a1 1 0 00-1-1H4a1 1 0 00-1 1v14a1 1 0 001 1z" />
                                </svg>
                            </div>
                            <h3 className="text-xl font-bold text-[#3aabd2] mb-3">早送りさせない再生</h3>
                            <p className="text-sm font-bold text-gray-800 leading-relaxed">
                                教育コンテンツの全内容を<br/>確実に視聴させるための機能
                            </p>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-2">
                        {[
                            { step: "ご契約", type: "start" },
                            { step: "アカウント\n発行", type: "mid" },
                            { step: "受講開始", type: "mid" },
                            { step: "修了証\n発行", type: "end" }
                        ].map((item, index) => (
                            <div key={index} className="relative h-24 filter drop-shadow-md transform transition-transform hover:-translate-y-1">
                                <div className={`
                                    absolute inset-0 bg-white flex items-center justify-center text-center
                                    ${index === 0 
                                        ? 'md:[clip-path:polygon(0%_0%,90%_0%,100%_50%,90%_100%,0%_100%)]' 
                                        : 'md:[clip-path:polygon(0%_0%,90%_0%,100%_50%,90%_100%,0%_100%,10%_50%)]'
                                    }
                                    rounded-lg md:rounded-none
                                `}>
                                    <h4 className="text-2xl font-bold text-[#b91c1c] whitespace-pre-line leading-snug">{item.step}</h4>
                                </div>
                                {/* Mobile Arrow Indicator (Down) */}
                                {index < 3 && (
                                    <div className="md:hidden absolute -bottom-6 left-1/2 transform -translate-x-1/2 text-gray-300">
                                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" /></svg>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="py-20 bg-white">
                <div className="container mx-auto px-6">
                    <h2 className="text-3xl font-bold text-center mb-12 relative pb-4 after:content-[''] after:absolute after:left-1/2 after:-translate-x-1/2 after:bottom-0 after:w-16 after:h-1 after:bg-[#3aabd2] after:rounded-full">
                        活用可能な助成金
                    </h2>
                    <div className="grid md:grid-cols-2 gap-12 items-center">
                        <div>
                            <h3 className="text-2xl font-bold text-[#3aabd2] mb-4">人材開発支援助成金<br />事業展開等リスキリング支援コース</h3>
                            <p className="text-gray-600 mb-6">事業展開等リスキリング支援コースは、企業の成長のために必要な人材育成を支援する助成金です。AIの導入・活用に必要なスキルの習得を支援します。</p>
                            <ul className="space-y-3 mb-8">
                                {[
                                    '従業員のAI活用スキル習得を支援',
                                    '研修費用の最大75%が助成対象',
                                    'OJTとOff-JTの組み合わせが可能',
                                    '中小企業向けの特別枠あり'
                                ].map(item => (
                                    <li key={item} className="flex items-start">
                                        <svg className="w-5 h-5 text-green-500 mr-3 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path></svg>
                                        <span className="text-gray-700">{item}</span>
                                    </li>
                                ))}
                            </ul>
                            <a href="https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/koyou_roudou/koyou/kyufukin/d01-1.html" target="_blank" rel="noopener noreferrer" className="inline-block bg-gray-800 text-white font-bold py-3 px-8 rounded-lg shadow-lg hover:bg-gray-700 transition-colors">
                                詳細を確認する
                            </a>
                        </div>
                        <div>
                           {/* 2. img src をインポートした変数に差し替え */}
                           <img src={serviceAiTrainingSubsidySimulationImg} alt="助成金シミュレーション" className="rounded-xl shadow-2xl w-full" />
                        </div>
                    </div>
                    <p className="text-right text-sm text-gray-500 mt-12">最終更新日：2025年4月1日</p>
                </div>
            </section>
        </div>
    );
};

export default AITrainingPage;